import { Hidden } from '@mui/material'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { TailSpin } from 'react-loading-icons'
import { FilterOptions } from 'src/components/FilterOptions/FilterOptions'
import { Filter } from 'src/components/global/filter'
import { LoadingAnimation } from 'src/components/global/LoadingAnimation'
// import { SortbyDropdown, SortByType } from 'src/components/global/SortbyDropdown'
import { Pagination } from 'src/components/Pagination/Pagination'
import { ShareResourceList } from 'src/components/ShareResourceList/ShareResourceList'
import {
  IContentEntity,
  IEnum_Content_Contenttype,
  IMySharedContentsFilters,
  useMySharedContentsLazyQuery,
} from 'src/graphql/generated/hooks'
import { useUpdateQueryParams } from 'src/hooks/useUpdateQueryParams'
import { FilterOption } from 'src/types'

import { FilterDialog } from '../FilterDialog/FilterDialog'

interface Props {
  filterProps: FilterOption[]
  showDocumentType?: boolean
  contentType?: IEnum_Content_Contenttype
  filtersDisabled?: boolean
  // sortType?: SortByType
  onClickWhenDisabled?: () => void
  searchKeyword?: string
}

const pageSize = 10

export const ShareResources: React.FC<Props> = ({
  filterProps,
  showDocumentType = false,
  contentType,
  filtersDisabled = false,
  // sortType = 'contents',
  searchKeyword,
}) => {
  const router = useRouter()
  const [totalCount, setTotalCount] = useState(0)
  const [items, setCurrentItems] = useState<IContentEntity[]>([])
  const [showFilterDlg, setShowFilterDlg] = useState(false)
  const [loadContents, { data: contentsData, loading }] = useMySharedContentsLazyQuery()
  const { updateQueryParams } = useUpdateQueryParams()
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    const filters = router.query

    let selection: string[] = []
    if (filters.productType) {
      const paths = (filters.productType as string).split('_')
      const checks = paths[0].split(',')

      checks.map((check) => {
        const subTopicDocumentId = check.split('@@@@')[1]
        selection.push(subTopicDocumentId)
      })
    }
    selection = [...new Set(selection)]
    const newProductType = selection.join(',')
    const offset = 0
    const limit = 10
    const query = {
      contentType: contentType || (filters?.contentType as string),
      subTopicIds: filters ? newProductType : '',
    } as IMySharedContentsFilters
    loadContents({ variables: { offset, limit, query } })
  }, [filtersDisabled, router])

  useEffect(() => {
    if (contentsData) {
      const posts: any[] =
        contentsData.mySharedContents.contents?.map((contentWithAttr) => {
          return {
            ...contentWithAttr.attributes,
            id: contentWithAttr.id,
          }
        }) || []
      setCurrentItems(posts)
      setTotalCount(contentsData.mySharedContents.total || 0)
    }
  }, [contentsData])

  const navigateToPage = (page: number) => {
    updateQueryParams({ page: page.toString() }, true)
  }

  // Change page
  const paginateFront = () => {
    const lastpage = totalCount / pageSize
    if (currentPage < lastpage) {
      setCurrentPage(currentPage + 1)
      navigateToPage(currentPage + 1)
    }
  }
  const paginateBack = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
      navigateToPage(currentPage - 1)
    }
  }
  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
    navigateToPage(pageNumber)
  }
  return (
    <div className="flex flex-col flex-1">
      <div className="md:px-5 pt-5 md:pt-10">
        <Hidden mdDown>
          <FilterOptions
            filterOptions={filterProps}
            className="md:my-[1rem] md:mt-0 mt-[16px] md:mb-0 mb-[20px] min-h-[28px] mr-[180px]"
          />
        </Hidden>

        <div className="flex flex-row justify-between md:items-center h-10 md:mb-[1rem] font-primary font-medium">
          <Hidden mdDown>
            {loading && (
              <div className="flex items-center">
                <TailSpin stroke="#011D58" height="2em" /> <div className="pl-3"> Loading...</div>
              </div>
            )}
            {!loading && (
              <div className="font-primary font-medium">
                {(totalCount ?? 0) > 0
                  ? `${totalCount ?? 0} Content${(totalCount ?? 0) > 1 ? 's' : ''} Found`
                  : `No content found`}
              </div>
            )}
            {/* <SortbyDropdown className="w-54 font-primary font-medium" type={sortType} /> */}
          </Hidden>
          <Hidden mdUp>
            <div className="flex flex-col">
              <Filter onClickFilter={() => setShowFilterDlg(true)} />
            </div>
            {/* <SortbyDropdown className="w-54 font-primary font-medium" type={sortType} /> */}
          </Hidden>
        </div>

        <Hidden mdUp>
          <div className="flex flex-col">
            {loading && (
              <div className="flex items-center">
                <TailSpin stroke="#011D58" height="2em" /> <div className="pl-3"> Loading...</div>
              </div>
            )}
            {!loading && (
              <div className="font-primary font-medium text-[12px] leading-[26px]">
                {(totalCount ?? 0) > 0
                  ? `${totalCount ?? 0} Content${(totalCount ?? 0) > 1 ? 's' : ''} Found`
                  : `No content found`}
              </div>
            )}
            <FilterOptions
              filterOptions={filterProps}
              className="md:my-[1rem] md:mt-0 mt-[16px] md:mb-0 mb-[20px] min-h-[28px]"
            />
          </div>
        </Hidden>

        {loading && <LoadingAnimation></LoadingAnimation>}
        {!loading && (
          <>
            <ShareResourceList items={items} showDocumentType={showDocumentType} searchKeyword={searchKeyword} />
            {totalCount > 0 && (
              <Pagination
                postsPerPage={pageSize}
                totalPosts={totalCount}
                paginateBack={paginateBack}
                paginateFront={paginateFront}
                paginate={paginate}
                currentPage={currentPage}
                className="md:pt-[1.875rem] pt-[0.875rem]"
              />
            )}
          </>
        )}
      </div>
      <FilterDialog showFilterDlg={showFilterDlg} setShowFilterDlg={setShowFilterDlg} filterProps={filterProps} />
    </div>
  )
}
